package ui.screens

import androidx.compose.runtime.*
import org.jetbrains.compose.web.dom.*
import ui.components.Navbar
import ui.components.Footer as SiteFooter
import org.w3c.dom.HTMLElement
import kotlinx.browser.window

@Composable
fun TermsScreen(
    onBack: () -> Unit,
    onNavigateToPrivacy: () -> Unit = {}
) {
    var showBackToTop by remember { mutableStateOf(false) }

    LaunchedEffect(Unit) {
        window.onscroll = {
            showBackToTop = window.pageYOffset > 400
            null
        }
    }

    Div(attrs = {
        classes("min-h-screen", "bg-white", "dark:bg-medical-bgDark", "transition-colors", "duration-300")
    }) {
        Navbar(onNavigateHome = onBack)

        Div(attrs = {
            classes("max-w-4xl", "mx-auto", "pt-40", "pb-20", "px-6")
        }) {
            // Header
            Header {
                H1(attrs = { classes("text-3xl", "md:text-4xl", "font-bold", "text-gray-900", "dark:text-medical-onSurfaceDark", "mb-4") }) {
                    Text("Términos y Condiciones de Uso")
                }
                P(attrs = { classes("text-gray-500", "dark:text-gray-400", "mb-12") }) {
                    Text("Última actualización: 24 de Julio de 2026")
                }
            }

            Section(attrs = { classes("prose", "prose-slate", "dark:prose-invert", "max-w-none", "text-gray-700", "dark:text-gray-300", "leading-relaxed") }) {
                
                P(attrs = { classes("mb-8") }) {
                    Text("Bienvenido a DrRecipe. Al acceder, descargar o utilizar esta aplicación móvil, usted acepta cumplir con los presentes Términos y Condiciones de Uso.")
                }

                LegalSection("1. Definiciones") {
                    Ul {
                        ListItem { B { Text("“La Aplicación”:") }; Text(" se refiere a DrRecipe, una aplicación destinada a asistir a profesionales de la salud en la generación de documentos médicos como recetas, certificados médicos, solicitudes de estudios, informes clínicos y documentos relacionados.") }
                        ListItem { B { Text("“El Usuario”:") }; Text(" toda persona que descarga, se registra o utiliza la Aplicación. Al utilizar la Aplicación, el Usuario declara ser mayor de edad y contar con plena capacidad legal para contratar.") }
                        ListItem { B { Text("“Profesional Médico”:") }; Text(" usuario que declara y acredita ser un profesional de la salud debidamente habilitado para ejercer en su país de actividad.") }
                    }
                }

                LegalSection("2. Acceso y Registro") {
                    P { Text("El uso de las funcionalidades principales de la Aplicación está destinado exclusivamente a profesionales de la salud.") }
                    P { Text("Para registrarse y utilizar la Aplicación, el Usuario deberá proporcionar información veraz, que puede incluir:") }
                    Ul {
                        ListItem { Text("Nombre y apellido") }
                        ListItem { Text("País de ejercicio profesional") }
                        ListItem { Text("Número de matrícula profesional") }
                        ListItem { Text("Colegio, consejo o entidad profesional correspondiente") }
                    }
                    P { Text("DrRecipe se reserva el derecho de:") }
                    Ul {
                        ListItem { Text("Verificar manualmente la información proporcionada") }
                        ListItem { Text("Solicitar documentación adicional") }
                        ListItem { Text("Aprobar, rechazar o suspender cuentas que no cumplan con los requisitos") }
                    }
                    P { Text("El Usuario es el único responsable de la exactitud y validez de los datos proporcionados.") }
                    P { Text("DrRecipe se reserva el derecho de cancelar el acceso y rescindir la cuenta cuando se detecten incumplimientos de estos términos, suplantación de identidad o actividades fraudulentas.") }
                    P { Text("Cualquier modificación posterior en los datos profesionales (firma, sello, número de matrícula) invalidará la verificación actual, requiriendo un nuevo proceso de revisión manual durante el cual el acceso a ciertas funciones podría verse restringido.") }
                }

                LegalSection("3. Uso Aceptable") {
                    P { Text("El Usuario se compromete a utilizar la Aplicación de manera ética, legal y profesional.") }
                    P { Text("Queda expresamente prohibido:") }
                    Ul {
                        ListItem { Text("Generar documentación médica falsa o fraudulenta") }
                        ListItem { Text("Suplantar identidad profesional") }
                        ListItem { Text("Utilizar la Aplicación para el ejercicio ilegal de la medicina") }
                    }
                    P { Text("Cualquier uso indebido podrá resultar en la suspensión o cancelación inmediata de la cuenta, sin derecho a reclamo, y podrá ser informado a las autoridades competentes si correspondiera.") }
                }

                LegalSection("4. Almacenamiento y Seguridad de Datos") {
                    P { Text("La información proporcionada por el Usuario, incluyendo firmas, sellos y documentos generados, se almacena utilizando infraestructura segura en la nube de terceros como Firebase (Google). El tratamiento de datos está sujeto también a las condiciones y medidas de seguridad de dicho proveedor.") }
                    P { Text("DrRecipe implementa medidas razonables de seguridad para proteger la información, sin embargo:") }
                    Ul {
                        ListItem { Text("No garantiza la invulnerabilidad absoluta de los sistemas ante ataques informáticos externos") }
                        ListItem { Text("El Usuario es responsable del uso y resguardo de la información de sus pacientes en su propio dispositivo") }
                        ListItem { Text("El Usuario acepta que parte de la información puede ser procesada o almacenada en servidores ubicados fuera de su país de residencia, aplicándose los estándares internacionales de seguridad del proveedor.") }
                        ListItem { Text("La información no será compartida con terceros con fines comerciales, salvo obligación legal o requerimiento judicial.") }
                    }
                    P { B { Text("Eliminación de Cuenta y Datos:") }; Text(" El Usuario tiene el derecho de eliminar su cuenta en cualquier momento desde los ajustes de la Aplicación. Esta acción es irreversible y conlleva la eliminación permanente de todos los registros de pacientes, consultas, firmas y sellos asociados, de acuerdo con los plazos de seguridad de nuestros proveedores de servicios (Firebase).") }
                }

                LegalSection("5. Documentos Generados y Responsabilidad Profesional") {
                    P { Text("DrRecipe es una herramienta de apoyo para la práctica profesional.") }
                    P { Text("El Usuario garantiza que es el titular legítimo de la firma y sello cargados en la Aplicación. DrRecipe actúa únicamente como procesador de estas imágenes para su inserción en los documentos PDF generados.") }
                    Ul {
                        ListItem { Text("El Usuario declara contar con la base legal, autorización o consentimiento informado necesario para tratar los datos personales y de salud de sus pacientes conforme a la legislación aplicable en su país.") }
                        ListItem { Text("Es responsabilidad obligatoria del Usuario obtener el consentimiento informado del paciente antes de la gestión de sus datos y la emisión de documentos digitales. La Aplicación integra un mecanismo de validación que bloquea la generación de archivos PDF hasta que el profesional confirme haber cumplido con este requisito legal.") }
                        ListItem { Text("La responsabilidad sobre el contenido, validez y uso de los documentos generados recae exclusivamente en el profesional que los emite") }
                        ListItem { Text("La Aplicación no reemplaza el criterio médico ni los sistemas oficiales de salud") }
                        ListItem { Text("DrRecipe no garantiza validaciones automáticas de matrículas o licencias profesionales, ya que estas pueden depender de fuentes públicas o procesos manuales") }
                        ListItem { Text("Los documentos PDF generados previamente pueden no reflejar cambios realizados posteriormente en la ficha clínica del paciente. Es responsabilidad del Usuario regenerar y verificar la versión final del documento antes de su entrega al paciente.") }
                    }
                }

                LegalSection("6. Suscripciones y Pagos") {
                    P { Text("Algunas funciones de la Aplicación pueden estar sujetas a planes de suscripción.") }
                    Ul {
                        ListItem { Text("DrRecipe puede ofrecer un periodo de prueba gratuito limitado. Al finalizar dicho periodo, el acceso a funciones de creación y edición de documentos quedará restringido hasta la contratación de un plan de suscripción activo.") }
                        ListItem { Text("Los pagos y renovaciones se gestionan exclusivamente a través de Google Play") }
                        ListItem { Text("Las condiciones de facturación, cancelación y reembolsos se rigen por las políticas de Google") }
                        ListItem { Text("DrRecipe no almacena ni procesa datos financieros del Usuario") }
                    }
                }

                LegalSection("7. Propiedad Intelectual") {
                    P { Text("El nombre DrRecipe, el logotipo, el diseño de la interfaz, el código fuente y todos los contenidos originales de la Aplicación son propiedad exclusiva de sus titulares. Queda expresamente prohibida su copia, distribución, ingeniería inversa o uso no autorizado sin consentimiento previo por escrito.") }
                }

                LegalSection("8. Disponibilidad y Limitación de Responsabilidad") {
                    P { Text("La Aplicación puede recibir mantenimiento, actualizaciones o sufrir interrupciones temporales por causas técnicas o de fuerza mayor sin previo aviso.") }
                    P { Text("DrRecipe no será responsable por daños, pérdida de información o lucro cesante derivados de:") }
                    Ul {
                        ListItem { Text("Interrupciones del servicio o fallos en la conexión a internet") }
                        ListItem { Text("Errores en el dispositivo del usuario o incompatibilidades de software") }
                        ListItem { Text("Uso indebido de la documentación generada por parte del Usuario o terceros.") }
                    }
                }

                LegalSection("9. Modificaciones") {
                    P { Text("DrRecipe se reserva el derecho de modificar estos Términos y Condiciones en cualquier momento. Las modificaciones serán notificadas dentro de la Aplicación y entrarán en vigor a partir de su publicación.") }
                    P { Text("El uso continuado de la Aplicación implica la aceptación de los términos actualizados.") }
                }

                LegalSection("10. Ley Aplicable") {
                    P { Text("Estos Términos y Condiciones se rigen por las leyes vigentes de la República Bolivariana de Venezuela, país de domicilio de los titulares de la Aplicación, sin perjuicio de las normas de orden público vigentes en el país donde el Usuario ejerza su actividad.") }
                }

                LegalSection("11. Contacto") {
                    P { Text("Para consultas relacionadas con estos Términos y Condiciones:") }
                    A(href = "mailto:soporte@drrecipeapp.com", attrs = { classes("text-medical-primary", "font-bold", "no-underline") }) {
                        Text("soporte@drrecipeapp.com")
                    }
                }

                // --- NUEVO: NAVEGACIÓN ENTRE PÁGINAS LEGALES ---
                Div(attrs = { classes("mt-20", "pt-10", "border-t", "border-gray-200", "dark:border-medical-surfaceVariantDark", "flex", "justify-between", "items-center") }) {
                    Div {
                        P(attrs = { classes("text-sm", "text-gray-500", "dark:text-gray-400", "mb-1") }) { Text("¿Deseas ver cómo protegemos tus datos?") }
                        A(href = "javascript:void(0)", attrs = { 
                            classes("text-medical-primary", "dark:text-medical-primaryDark", "font-bold", "hover:underline") 
                            onClick { window.location.href = "/?p=privacy" }
                        }) { Text("Ver Política de Privacidad →") }
                    }
                }
            }

        }

        SiteFooter(
            onNavigateToTerms = {},
            onNavigateToPrivacy = onNavigateToPrivacy
        )

        if (showBackToTop) {
            Div(attrs = {
                classes("fixed", "bottom-8", "right-8", "z-50", "bg-medical-primary", "dark:bg-medical-primaryDark", "text-white", "dark:text-medical-bgDark", "p-4", "rounded-full", "shadow-2xl", "cursor-pointer")
                onClick { window.scrollTo(0.0, 0.0) }
            }) { Span(attrs = { classes("material-symbols-outlined") }) { Text("keyboard_arrow_up") } }
        }
    }
}

@Composable
private fun LegalSection(title: String, content: ContentBuilder<HTMLElement>) {
    Div(attrs = { classes("mb-10") }) {
        H2(attrs = { classes("text-xl", "font-bold", "text-gray-900", "dark:text-medical-onSurfaceDark", "mb-4") }) { Text(title) }
        content()
    }
}

@Composable
private fun ListItem(content: ContentBuilder<HTMLElement>) {
    Li(attrs = { classes("mb-2", "ml-4", "list-disc") }) { content() }
}
